import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgChevronUpDown = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8091 13L18 14.3161L11 20L4 14.3161L5.19087 13L11 17.7169L16.8091 13Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.19087 9L4 7.68386L11 2L18 7.68386L16.8091 9L11 4.2831L5.19087 9Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgChevronUpDown);

export default ForwardRef;
